import type { PaletteOptions } from "@mui/material";

export const COLORS = {
  primary: {
    main: "#FF6234", // this matches primary50
  },
  text10: {
    main: "#FFFFFF",
  },
  text20: {
    main: "#CBCBCB",
  },
  text30: {
    main: "#868686",
  },
  text40: {
    main: "#636363",
  },
  text50: {
    main: "#1C1C1C",
  },
  accentDanger10: {
    main: "#FEDBDA",
  },
  accentDanger20: {
    main: "#FF9393",
  },
  accentDanger30: {
    main: "#FC4444",
  },
  accentDanger40: {
    main: "#B4091F",
  },
  accentDanger50: {
    main: "#730015",
  },
  accentInfo10: {
    main: "#CCEBFE",
  },
  accentInfo20: {
    main: "#7BCCFF",
  },
  accentInfo30: {
    main: "#009BFC",
  },
  accentInfo50: {
    main: "#002F4C",
  },
  accentInfo40: {
    main: "#005D97",
  },
  accentSuccess10: {
    main: "#D0F2CE",
  },
  accentSuccess20: {
    main: "#9AEA95",
  },
  accentSuccess30: {
    main: "#0AC400",
  },
  accentSuccess40: {
    main: "#3B7E37",
  },
  accentSuccess50: {
    main: "#275425",
  },
  accentWarning10: {
    main: "#FEEEBD",
  },
  accentWarning20: {
    main: "#FDDD7B",
  },
  accentWarning30: {
    main: "#E1A800",
  },
  accentWarning40: {
    main: "#B68411",
  },
  accentWarning50: {
    main: "#785106",
  },
  dataCerulean: {
    main: "#4575B4",
  },
  dataLime: {
    main: "#7FBC41",
  },
  dataPeach: {
    main: "#FDAE61",
  },
  dataSky: {
    main: "#ABD9E9",
  },
  dataMagenta: {
    main: "#C51B7D",
  },
  dataMaroon: {
    main: "#A50026",
  },
  dataRed: {
    main: "#D73027",
  },
  dataGinger: {
    main: "#F46D43",
  },
  dataCream: {
    main: "#FEE090",
  },
  dataArctic: {
    main: "#74ADDD",
  },
  dataNavy: {
    main: "#313695",
  },
  overlay: {
    main: "rgba(0, 0, 0, 0.4)",
  },
  surfaceLight10: {
    main: "#FFFFFF",
  },
  surfaceLight20: {
    main: "#F7F7F7",
  },
  surfaceLight30: {
    main: "#F1F0EF",
  },
  surfaceLight40: {
    main: "#E5E5E5",
  },
  surfaceLight50: {
    main: "#CBCBCB",
  },
  surfaceDark10: {
    main: "#868686",
  },
  surfaceDark20: {
    main: "#636363",
  },
  surfaceDark30: {
    main: "#383838",
  },
  surfaceDark40: {
    main: "#202020",
  },
  surfaceDark50: {
    main: "#050505",
  },
  primary10: {
    main: "#FFE0D6",
  },
  primary20: {
    main: "#FFC0AE",
  },
  primary30: {
    main: "#FFA185",
  },
  primary40: {
    main: "#FF815D",
  },
  primary50: {
    main: "#FF6234",
  },
  primary60: {
    main: "#CE4F2A",
  },
  primary70: {
    main: "#9D3C1F",
  },
  primary80: {
    main: "#6D2915",
  },
  primary90: {
    main: "#3C160A",
  },
  primary100: {
    main: "#230D05",
  },
  secondary10: {
    main: "#E5D7F6",
  },
  secondary20: {
    main: "#CAB0ED",
  },
  secondary30: {
    main: "#B088E4",
  },
  secondary40: {
    main: "#9561DB",
  },
  secondary50: {
    main: "#7B39D2",
  },
  secondary60: {
    main: "#622EA8",
  },
  secondary70: {
    main: "#4A227E",
  },
  secondary80: {
    main: "#311754",
  },
  secondary90: {
    main: "#25113F",
  },
};

const sbPalette: PaletteOptions = {
  ...COLORS,
  contrastThreshold: 3,
  tonalOffset: 0.2,
};
const sbDarkPalette: PaletteOptions = {
  primary: {
    main: "#FF6234", // this matches primary50
  },
  text10: {
    main: "#1C1C1C",
  },
  text20: {
    main: "#636363",
  },
  text30: {
    main: "#868686",
  },
  text40: {
    main: "#CBCBCB",
  },
  text50: {
    main: "#F1F0EF",
  },
  accentDanger10: {
    main: "#730015",
  },
  accentDanger20: {
    main: "#B4091F",
  },
  accentDanger30: {
    main: "#FC4444",
  },
  accentDanger40: {
    main: "#FF9393",
  },
  accentDanger50: {
    main: "#FEDBDA",
  },
  accentInfo10: {
    main: "#002F4C",
  },
  accentInfo20: {
    main: "#02609B",
  },
  accentInfo30: {
    main: "#009BFC",
  },
  accentInfo40: {
    main: "#7BCCFF",
  },
  accentInfo50: {
    main: "#CCEBFE",
  },
  accentSuccess10: {
    main: "#275425",
  },
  accentSuccess20: {
    main: "#3B7E37",
  },
  accentSuccess30: {
    main: "#0AC400",
  },
  accentSuccess40: {
    main: "#9AEA95",
  },
  accentSuccess50: {
    main: "#D0F2CE",
  },
  accentWarning10: {
    main: "#785106",
  },
  accentWarning20: {
    main: "#B68411",
  },
  accentWarning30: {
    main: "#E1A800",
  },
  accentWarning40: {
    main: "#FFD861",
  },
  accentWarning50: {
    main: "#FEEEBD",
  },
  dataCerulean: {
    main: "#4575B4",
  },
  dataLime: {
    main: "#7FBC41",
  },
  dataPeach: {
    main: "#FDAE61",
  },
  dataSky: {
    main: "#ABD9E9",
  },
  dataMagenta: {
    main: "#C51B7D",
  },
  dataMaroon: {
    main: "#A50026",
  },
  dataRed: {
    main: "#D73027",
  },
  dataGinger: {
    main: "#F46D43",
  },
  dataCream: {
    main: "#FEE090",
  },
  dataArctic: {
    main: "#74ADDD",
  },
  dataNavy: {
    main: "#313695",
  },
  overlay: {
    main: "rgba(0, 0, 0, 0.7)",
  },
  surfaceLight10: {
    main: "#050505",
  },
  surfaceLight20: {
    main: "#1C1C1C",
  },
  surfaceLight30: {
    main: "#383838",
  },
  surfaceLight40: {
    main: "#636363",
  },
  surfaceLight50: {
    main: "#868686",
  },
  surfaceDark10: {
    main: "#CBCBCB",
  },
  surfaceDark20: {
    main: "#E5E5E5",
  },
  surfaceDark30: {
    main: "#F1F0EF",
  },
  surfaceDark40: {
    main: "#F7F7F7",
  },
  surfaceDark50: {
    main: "#FFFFFF",
  },
  primary10: {
    main: "#3C160A",
  },
  primary20: {
    main: "#6D2915",
  },
  primary30: {
    main: "#9D3C1F",
  },
  primary40: {
    main: "#CE4F2A",
  },
  primary50: {
    main: "#FF6234",
  },
  primary60: {
    main: "#FF815D",
  },
  primary70: {
    main: "#FFA185",
  },
  primary80: {
    main: "#FFC0AE",
  },
  primary90: {
    main: "#FFE0D6",
  },
  primary100: {
    main: "#FFE0D6",
  },
  secondary10: {
    main: "#4A227E",
  },
  secondary20: {
    main: "#622EA8",
  },
  secondary30: {
    main: "#7B39D2",
  },
  secondary40: {
    main: "#9561DB",
  },
  secondary50: {
    main: "#B088E4",
  },
  secondary60: {
    main: "#CAB0ED",
  },
  secondary70: {
    main: "#E5D7F6",
  },
  secondary80: {
    main: "#E5D7F6",
  },
  secondary90: {
    main: "#E5D7F6",
  },
};

declare module "@mui/material/styles" {
  interface Palette {
    text10: Palette["primary"];
    text20: Palette["secondary"];
    text30: Palette["secondary"];
    text40: Palette["secondary"];
    text50: Palette["secondary"];
    accentDanger10: Palette["error"];
    accentDanger20: Palette["error"];
    accentDanger30: Palette["error"];
    accentDanger40: Palette["error"];
    accentDanger50: Palette["error"];
    accentInfo10: Palette["info"];
    accentInfo20: Palette["info"];
    accentInfo30: Palette["info"];
    accentInfo40: Palette["info"];
    accentInfo50: Palette["info"];
    accentSuccess10: Palette["success"];
    accentSuccess20: Palette["success"];
    accentSuccess30: Palette["success"];
    accentSuccess40: Palette["success"];
    accentSuccess50: Palette["success"];
    accentWarning10: Palette["warning"];
    accentWarning20: Palette["warning"];
    accentWarning30: Palette["warning"];
    accentWarning40: Palette["warning"];
    accentWarning50: Palette["warning"];
    dataCerulean: Palette["primary"];
    dataLime: Palette["primary"];
    dataPeach: Palette["primary"];
    dataSky: Palette["primary"];
    dataMagenta: Palette["primary"];
    dataMaroon: Palette["primary"];
    dataRed: Palette["primary"];
    dataGinger: Palette["primary"];
    dataCream: Palette["primary"];
    dataArctic: Palette["primary"];
    dataNavy: Palette["primary"];
    overlay: Palette["primary"];
    surfaceLight10: Palette["primary"];
    surfaceLight20: Palette["primary"];
    surfaceLight30: Palette["primary"];
    surfaceLight40: Palette["primary"];
    surfaceLight50: Palette["primary"];
    surfaceDark10: Palette["primary"];
    surfaceDark20: Palette["primary"];
    surfaceDark30: Palette["primary"];
    surfaceDark40: Palette["primary"];
    surfaceDark50: Palette["primary"];
    primary10: Palette["primary"];
    primary20: Palette["primary"];
    primary30: Palette["primary"];
    primary40: Palette["primary"];
    primary50: Palette["primary"];
    primary60: Palette["primary"];
    primary70: Palette["primary"];
    primary80: Palette["primary"];
    primary90: Palette["primary"];
    primary100: Palette["primary"];
    secondary10: Palette["secondary"];
    secondary20: Palette["secondary"];
    secondary30: Palette["secondary"];
    secondary40: Palette["secondary"];
    secondary50: Palette["secondary"];
    secondary60: Palette["secondary"];
    secondary70: Palette["secondary"];
    secondary80: Palette["secondary"];
    secondary90: Palette["secondary"];
  }
  interface PaletteOptions {
    text10?: PaletteOptions["primary"];
    text20?: PaletteOptions["secondary"];
    text30?: PaletteOptions["secondary"];
    text40?: PaletteOptions["secondary"];
    text50?: PaletteOptions["secondary"];
    accentDanger10?: PaletteOptions["error"];
    accentDanger20?: PaletteOptions["error"];
    accentDanger30?: PaletteOptions["error"];
    accentDanger40?: PaletteOptions["error"];
    accentDanger50?: PaletteOptions["error"];
    accentInfo10?: PaletteOptions["info"];
    accentInfo20?: PaletteOptions["info"];
    accentInfo30?: PaletteOptions["info"];
    accentInfo40?: PaletteOptions["info"];
    accentInfo50?: PaletteOptions["info"];
    accentSuccess10?: PaletteOptions["success"];
    accentSuccess20?: PaletteOptions["success"];
    accentSuccess30?: PaletteOptions["success"];
    accentSuccess40?: PaletteOptions["success"];
    accentSuccess50?: PaletteOptions["success"];
    accentWarning10?: PaletteOptions["warning"];
    accentWarning20?: PaletteOptions["warning"];
    accentWarning30?: PaletteOptions["warning"];
    accentWarning40?: PaletteOptions["warning"];
    accentWarning50?: PaletteOptions["warning"];
    dataCerulean?: PaletteOptions["primary"];
    dataLime?: PaletteOptions["primary"];
    dataPeach?: PaletteOptions["primary"];
    dataSky?: PaletteOptions["primary"];
    dataMagenta?: PaletteOptions["primary"];
    dataMaroon?: PaletteOptions["primary"];
    dataRed?: PaletteOptions["primary"];
    dataGinger?: PaletteOptions["primary"];
    dataCream?: PaletteOptions["primary"];
    dataArctic?: PaletteOptions["primary"];
    dataNavy?: PaletteOptions["primary"];
    overlay?: PaletteOptions["primary"];
    surfaceLight10?: PaletteOptions["primary"];
    surfaceLight20?: PaletteOptions["primary"];
    surfaceLight30?: PaletteOptions["primary"];
    surfaceLight40?: PaletteOptions["primary"];
    surfaceLight50?: PaletteOptions["primary"];
    surfaceDark10?: PaletteOptions["primary"];
    surfaceDark20?: PaletteOptions["primary"];
    surfaceDark30?: PaletteOptions["primary"];
    surfaceDark40?: PaletteOptions["primary"];
    surfaceDark50?: PaletteOptions["primary"];
    primary10?: PaletteOptions["primary"];
    primary20?: PaletteOptions["primary"];
    primary30?: PaletteOptions["primary"];
    primary40?: PaletteOptions["primary"];
    primary50?: PaletteOptions["primary"];
    primary60?: PaletteOptions["primary"];
    primary70?: PaletteOptions["primary"];
    primary80?: PaletteOptions["primary"];
    primary90?: PaletteOptions["primary"];
    primary100?: PaletteOptions["primary"];
    secondary10?: PaletteOptions["secondary"];
    secondary20?: PaletteOptions["secondary"];
    secondary30?: PaletteOptions["secondary"];
    secondary40?: PaletteOptions["secondary"];
    secondary50?: PaletteOptions["secondary"];
    secondary60?: PaletteOptions["secondary"];
    secondary70?: PaletteOptions["secondary"];
    secondary80?: PaletteOptions["secondary"];
    secondary90?: PaletteOptions["secondary"];
  }
}

export { sbDarkPalette, sbPalette };
